// Shared order status labels and colors for Admin Orders Dashboard and My Account Orders view
export const ORDER_STATUS_OPTIONS = [
  { key: 'pending', label: 'Pending', color: 'bg-gray-100 text-gray-800' },
  { key: 'processing', label: 'Processing', color: 'bg-yellow-100 text-yellow-800' },
  { key: 'in_queue_for_printing', label: 'In queue for printing', color: 'bg-yellow-100 text-yellow-800' },
  { key: 'printing_started', label: 'Printing started', color: 'bg-blue-100 text-blue-800' },
  { key: 'printed', label: 'Printed', color: 'bg-green-100 text-green-800' },
  { key: 'quality_check', label: 'Quality check', color: 'bg-purple-100 text-purple-800' },
  { key: 'packaging', label: 'Packaging', color: 'bg-indigo-100 text-indigo-800' },
  { key: 'in_production', label: 'In production', color: 'bg-indigo-100 text-indigo-800' },
  { key: 'ready_for_shipping', label: 'Ready for shipping', color: 'bg-orange-100 text-orange-800' },
  { key: 'shipped', label: 'Shipped', color: 'bg-teal-100 text-teal-800' },
  { key: 'in_transit', label: 'In transit', color: 'bg-cyan-100 text-cyan-800' },
  { key: 'out_for_delivery', label: 'Out for delivery', color: 'bg-pink-100 text-pink-800' },
  { key: 'on_way', label: 'On the way', color: 'bg-pink-100 text-pink-800' },
  { key: 'delivered', label: 'Delivered', color: 'bg-green-200 text-green-900' },
  { key: 'completed', label: 'Completed', color: 'bg-green-200 text-green-900' },
  { key: 'cancelled', label: 'Cancelled', color: 'bg-red-100 text-red-800' },
  { key: 'returned', label: 'Returned', color: 'bg-gray-100 text-gray-800' },
];

export function getOrderStatusLabel(status) {
  return ORDER_STATUS_OPTIONS.find(s => s.key === status)?.label || status || 'Unknown';
}

export function getOrderStatusColor(status) {
  return ORDER_STATUS_OPTIONS.find(s => s.key === status)?.color || 'bg-gray-100 text-gray-800';
}
